import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function FAQ() {
  const { i18n } = useTranslation(); // ✅ Suppression de 't' qui n'était pas utilisé
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const lang = i18n.language || 'fr';

  const toggleQuestion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = {
    fr: [
      {
        category: "🚀 Démarrage",
        questions: [
          {
            q: "Qu'est-ce que ProjectBoost ?",
            a: "ProjectBoost est une plateforme de diagnostic et d'optimisation de projets. En 30 minutes, vous identifiez les zones de friction de votre projet et obtenez un rapport détaillé avec des recommandations concrètes pour améliorer sa performance."
          },
          {
            q: "Comment fonctionne le diagnostic ?",
            a: "Le diagnostic se base sur un questionnaire structuré de 24 questions réparties en 6 axes clés. Vous répondez collectivement avec votre équipe (2-10 personnes), puis l'outil génère automatiquement un rapport d'analyse complet avec scores, constats et plan d'actions priorisé."
          },
          {
            q: "Combien de temps prend un diagnostic ?",
            a: "Un diagnostic complet prend environ 30 minutes. Ce temps inclut la réponse aux 24 questions en équipe et la génération automatique du rapport."
          },
          {
            q: "Qui peut utiliser ProjectBoost ?",
            a: "ProjectBoost s'adresse aux chefs de projet, managers, équipes projet et dirigeants qui souhaitent reprendre le contrôle de leurs projets, identifier les blocages et améliorer la performance globale."
          }
        ]
      },
      {
        category: "💳 Abonnements et tarifs",
        questions: [
          {
            q: "Quels sont les différents plans disponibles ?",
            a: "Nous proposons 3 options :\n\n• Gratuit : 1 diagnostic offert\n• Silver (29,99€/mois) : 3 diagnostics/mois + téléchargement PDF\n• Gold (49,99€/mois) : 7 diagnostics/mois + PDF + bibliothèque complète"
          },
          {
            q: "Puis-je essayer gratuitement ?",
            a: "Oui ! Chaque nouveau compte bénéficie d'un diagnostic gratuit. Vous pouvez tester la plateforme sans engagement et sans carte bancaire."
          },
          {
            q: "Comment puis-je changer d'abonnement ?",
            a: "Depuis votre tableau de bord ou la page Tarifs, cliquez sur 'Gérer mon abonnement'. Vous serez redirigé vers le portail Stripe où vous pourrez modifier, annuler ou mettre à jour votre plan."
          },
          {
            q: "Puis-je annuler mon abonnement à tout moment ?",
            a: "Oui, vous pouvez annuler votre abonnement à tout moment via le portail de gestion. L'annulation prend effet à la fin de votre période de facturation en cours."
          },
          {
            q: "Les paiements sont-ils sécurisés ?",
            a: "Oui, tous les paiements sont traités par Stripe, leader mondial du paiement en ligne. Nous ne stockons aucune information de carte bancaire sur nos serveurs."
          }
        ]
      },
      {
        category: "📊 Fonctionnalités",
        questions: [
          {
            q: "Que contient le rapport de diagnostic ?",
            a: "Le rapport contient :\n\n• Résumé exécutif avec score global\n• Scores détaillés par axe (6 axes)\n• Visualisation graphique\n• Analyse des dysfonctionnements\n• Causes racines et conséquences\n• Plan d'actions priorisé\n• Recommandations finales\n• Ressources conseillées"
          },
          {
            q: "Puis-je télécharger le rapport en PDF ?",
            a: "Oui, avec un abonnement Silver ou Gold. Le plan gratuit permet de consulter le rapport en ligne uniquement."
          },
          {
            q: "Qu'est-ce que la bibliothèque (Gold) ?",
            a: "La bibliothèque est une collection exclusive de 8 livres du Dr. Arthur MOMO KOUNTCHOU sur le management de projet, le leadership et le développement personnel. Accessible uniquement avec l'abonnement Gold."
          },
          {
            q: "Les diagnostics sont-ils sauvegardés ?",
            a: "Oui, tous vos diagnostics sont automatiquement sauvegardés dans votre compte. Vous pouvez y accéder à tout moment depuis votre tableau de bord."
          },
          {
            q: "Combien de personnes peuvent participer au diagnostic ?",
            a: "Le diagnostic est conçu pour 2 à 10 participants. Le chef de projet et son équipe répondent collectivement aux questions pour obtenir une vision partagée."
          }
        ]
      },
      {
        category: "🔐 Compte et sécurité",
        questions: [
          {
            q: "Comment créer un compte ?",
            a: "Cliquez sur 'Créer un compte', entrez votre email et choisissez un mot de passe (min. 6 caractères). Vous aurez immédiatement accès à votre diagnostic gratuit."
          },
          {
            q: "J'ai oublié mon mot de passe, que faire ?",
            a: "Sur la page de connexion, cliquez sur 'Mot de passe oublié ?'. Entrez votre email et vous recevrez un lien de réinitialisation. Vérifiez aussi votre dossier spam."
          },
          {
            q: "Mes données sont-elles sécurisées ?",
            a: "Oui, nous utilisons Firebase (Google Cloud) pour stocker vos données de manière sécurisée. Vos informations sont chiffrées et protégées selon les normes RGPD."
          },
          {
            q: "Puis-je supprimer mon compte ?",
            a: "Oui, contactez-nous à ace.direction22@gmail.com pour demander la suppression de votre compte et de toutes vos données."
          }
        ]
      },
      {
        category: "📚 Utilisation",
        questions: [
          {
            q: "Combien de diagnostics puis-je faire ?",
            a: "• Gratuit : 1 diagnostic\n• Silver : 3 diagnostics par mois\n• Gold : 7 diagnostics par mois\n• Le compteur se réinitialise chaque mois."
          },
          {
            q: "Que se passe-t-il si j'atteins ma limite ?",
            a: "Vous pouvez soit attendre le mois suivant (reset automatique), soit passer à un plan supérieur."
          },
          {
            q: "Puis-je modifier un diagnostic après l'avoir complété ?",
            a: "Non, une fois le diagnostic généré, il n'est plus modifiable. Cela garantit l'intégrité et la traçabilité de vos analyses. Vous pouvez cependant créer un nouveau diagnostic."
          },
          {
            q: "Comment lire les livres de la bibliothèque ?",
            a: "Avec l'abonnement Gold, accédez à la bibliothèque depuis votre tableau de bord. Cliquez sur un livre pour le lire directement. Les livres sont protégés par le droit d'auteur. Toute reproduction ou diffusion sans autorisation est interdite."
          },
          {
            q: "Puis-je partager mon rapport avec mon équipe ?",
            a: "Oui, une fois téléchargé en PDF (Silver/Gold), vous pouvez partager le rapport librement avec votre équipe ou votre hiérarchie."
          }
        ]
      },
      {
        category: "❓ Support",
        questions: [
          {
            q: "Comment contacter le support ?",
            a: "Pour toute question ou problème, nous vous invitons à consulter premièrement la section FAQ. Si vous ne trouvez pas de réponse, vous pouvez nous contacter : ace.direction22@gmail.com."
          },
          {
            q: "Proposez-vous une formation ?",
            a: "Oui, nous proposons des formations et accompagnements personnalisés. Contactez-nous pour plus d'informations."
          },
          {
            q: "Puis-je obtenir une facture ?",
            a: "Oui, toutes vos factures sont disponibles dans le portail Stripe (accessible via 'Gérer mon abonnement')."
          },
          {
            q: "Le service est-il disponible en plusieurs langues ?",
            a: "Oui, ProjectBoost est disponible en français et en anglais. Vous pouvez changer de langue depuis votre tableau de bord."
          }
        ]
      }
    ],
    en: [
      {
        category: "🚀 Getting Started",
        questions: [
          {
            q: "What is ProjectBoost?",
            a: "ProjectBoost is a project diagnostic and optimization platform. In 30 minutes, you identify friction zones in your project and get a detailed report with concrete recommendations to improve its performance."
          },
          {
            q: "How does the diagnostic work?",
            a: "The diagnostic is based on a structured questionnaire of 24 questions across 6 key axes. You answer collectively with your team (2-10 people), then the tool automatically generates a complete analysis report with scores, findings, and prioritized action plan."
          },
          {
            q: "How long does a diagnostic take?",
            a: "A complete diagnostic takes approximately 30 minutes. This includes answering the 24 questions as a team and automatic report generation."
          },
          {
            q: "Who can use ProjectBoost?",
            a: "ProjectBoost is designed for project managers, managers, project teams, and executives who want to regain control of their projects, identify blockages, and improve overall performance."
          }
        ]
      },
      {
        category: "💳 Subscriptions and Pricing",
        questions: [
          {
            q: "What plans are available?",
            a: "We offer 3 options:\n\n• Free: 1 diagnostic\n• Silver ($29.99/month): 3 diagnostics/month + PDF download\n• Gold ($49.99/month): 7 diagnostics/month + PDF + full library"
          },
          {
            q: "Can I try it for free?",
            a: "Yes! Every new account gets 1 free diagnostic. You can test the platform without commitment and without a credit card."
          },
          {
            q: "How can I change my subscription?",
            a: "From your dashboard or Pricing page, click 'Manage my subscription'. You'll be redirected to the Stripe portal where you can modify, cancel, or update your plan."
          },
          {
            q: "Can I cancel my subscription anytime?",
            a: "Yes, you can cancel your subscription anytime via the management portal. Cancellation takes effect at the end of your current billing period."
          },
          {
            q: "Are payments secure?",
            a: "Yes, all payments are processed by Stripe, the global leader in online payments. We never store any credit card information on our servers."
          }
        ]
      },
      {
        category: "📊 Features",
        questions: [
          {
            q: "What does the diagnostic report contain?",
            a: "The report contains:\n\n• Executive summary with global score\n• Detailed scores by axis (6 axes)\n• Graphical visualization\n• Dysfunction analysis\n• Root causes and consequences\n• Prioritized action plan\n• Final recommendations\n• Recommended resources"
          },
          {
            q: "Can I download the report as PDF?",
            a: "Yes, with a Silver or Gold subscription. The free plan allows online consultation only."
          },
          {
            q: "What is the library (Gold)?",
            a: "The library is an exclusive collection of 8 books by Dr. Arthur MOMO KOUNTCHOU on project management, leadership, and personal development. Only accessible with Gold subscription."
          },
          {
            q: "Are diagnostics saved?",
            a: "Yes, all your diagnostics are automatically saved in your account. You can access them anytime from your dashboard."
          },
          {
            q: "How many people can participate in the diagnostic?",
            a: "The diagnostic is designed for 2 to 10 participants. The project manager and team answer questions collectively to get a shared vision."
          }
        ]
      },
      {
        category: "🔐 Account and Security",
        questions: [
          {
            q: "How do I create an account?",
            a: "Click 'Create account', enter your email and choose a password (min. 6 characters). You'll immediately get access to your free diagnostic."
          },
          {
            q: "I forgot my password, what should I do?",
            a: "On the login page, click 'Forgot password?'. Enter your email and you'll receive a reset link. Also check your spam folder."
          },
          {
            q: "Is my data secure?",
            a: "Yes, we use Firebase (Google Cloud) to store your data securely. Your information is encrypted and protected according to GDPR standards."
          },
          {
            q: "Can I delete my account?",
            a: "Yes, contact us at ace.direction22@gmail.com to request deletion of your account and all your data."
          }
        ]
      },
      {
        category: "📚 Usage",
        questions: [
          {
            q: "How many diagnostics can I do?",
            a: "• Free: 1 diagnostic\n• Silver: 3 diagnostics per month\n• Gold: 7 diagnostics per month\n• Counter resets monthly."
          },
          {
            q: "What happens if I reach my limit?",
            a: "You can either wait for next month (automatic reset) or upgrade to a higher plan."
          },
          {
            q: "Can I edit a diagnostic after completion?",
            a: "No, once generated, a diagnostic cannot be modified. This ensures integrity and traceability of your analyses. You can however create a new diagnostic."
          },
          {
            q: "How do I read library books?",
            a: "With Gold subscription, access the library from your dashboard. Click a book to read it directly. The books are protected by copyright. Any reproduction or distribution without authorization is strictly prohibited."
          },
          {
            q: "Can I share my report with my team?",
            a: "Yes, once downloaded as PDF (Silver/Gold), you can freely share the report with your team or management."
          }
        ]
      },
      {
        category: "❓ Support",
        questions: [
          {
            q: "How do I contact support?",
            a: "For any questions or issues, we invite you to first consult the FAQ section. If you do not find an answer, you can contact us at: ace.direction22@gmail.com"
          },
          {
            q: "Do you offer training?",
            a: "Yes, we offer training and personalized support. Contact us for more information."
          },
          {
            q: "Can I get an invoice?",
            a: "Yes, all your invoices are available in the Stripe portal (accessible via 'Manage my subscription')."
          },
          {
            q: "Is the service available in multiple languages?",
            a: "Yes, ProjectBoost is available in French and English. You can change the language from your dashboard."
          }
        ]
      }
    ]
  };

  const currentFaq = faqData[lang] || faqData.fr;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow">
        <div className="max-w-7xl mx-auto px-4 py-6">
          <div className="flex justify-between items-center">
            <h1 className="text-3xl font-bold text-gray-900">
              {lang === 'fr' ? 'Questions fréquentes' : 'Frequently Asked Questions'}
            </h1>
            <button
              onClick={() => navigate('/dashboard')}
              className="text-gray-600 hover:text-gray-900 font-semibold"
            >
              ← {lang === 'fr' ? 'Retour au tableau de bord' : 'Back to dashboard'}
            </button>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 py-12">
        {/* Intro */}
        <div className="text-center mb-12">
          <p className="text-xl text-gray-600">
            {lang === 'fr' 
              ? 'Trouvez rapidement des réponses à vos questions sur ProjectBoost' 
              : 'Quickly find answers to your questions about ProjectBoost'}
          </p>
        </div>

        {/* FAQ Sections */}
        <div className="space-y-8">
          {currentFaq.map((section, sectionIndex) => (
            <div key={sectionIndex} className="bg-white rounded-lg shadow-sm p-6">
              <h2 className="text-2xl font-bold text-gray-900 mb-6">
                {section.category}
              </h2>
              
              <div className="space-y-4">
                {section.questions.map((item, questionIndex) => {
                  const globalIndex = `${sectionIndex}-${questionIndex}`;
                  const isOpen = openIndex === globalIndex;
                  
                  return (
                    <div
                      key={questionIndex}
                      className="border-b border-gray-200 last:border-b-0 pb-4 last:pb-0"
                    >
                      <button
                        onClick={() => toggleQuestion(globalIndex)}
                        className="w-full flex justify-between items-center text-left py-2 hover:text-blue-600 transition"
                      >
                        <span className="font-semibold text-gray-900 pr-4">
                          {item.q}
                        </span>
                        <span className="text-2xl text-blue-600 flex-shrink-0">
                          {isOpen ? '−' : '+'}
                        </span>
                      </button>
                      
                      {isOpen && (
                        <div className="mt-3 text-gray-700 whitespace-pre-line pl-2">
                          {item.a}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            {lang === 'fr' ? 'Vous ne trouvez pas votre réponse ?' : 'Can\'t find your answer?'}
          </h3>
          <p className="text-gray-600 mb-6">
            {lang === 'fr' 
              ? 'Notre équipe est là pour vous aider. Contactez-nous et nous vous répondrons rapidement.'
              : 'Our team is here to help. Contact us and we\'ll respond quickly.'}
          </p>
          <a
            href="mailto:ace.direction22@gmail.com"
            className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-8 rounded-lg transition"
          >
            📧 ace.direction22@gmail.com
          </a>
        </div>
      </main>
    </div>
  );
}

export default FAQ;
